var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/shape/star_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9198 2.8677C11.402 2.03987 12.598 2.03987 13.0801 2.8677L15.8751 7.66643L21.3027 8.84175C22.239 9.0445 22.6086 10.1819 21.9703 10.8963L18.2701 15.0374L18.8295 20.5625C18.926 21.5156 17.9585 22.2186 17.0818 21.8323L12 19.5929L6.91816 21.8323C6.04149 22.2186 5.07395 21.5156 5.17046 20.5625L5.72987 15.0374L2.02972 10.8963C1.3914 10.1819 1.76097 9.0445 2.69728 8.84175L8.12484 7.66643L10.9198 2.8677ZM12 4.98699L9.68673 8.95861C9.5101 9.26187 9.21413 9.4769 8.87114 9.55117L4.37906 10.5239L7.44146 13.9513C7.67529 14.2129 7.78834 14.5609 7.75299 14.91L7.29 19.4828L11.4959 17.6294C11.8171 17.4879 12.1829 17.4879 12.504 17.6294L16.71 19.4828L16.247 14.91C16.2116 14.5609 16.3247 14.2129 16.5585 13.9513L19.6209 10.5239L15.1288 9.55117C14.7858 9.4769 14.4899 9.26186 14.3132 8.95861L12 4.98699Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLine);
export default __webpack_public_path__ + "static/media/star_line.fdcb484c9f825620f90aa1c6d078d465.svg";
export { ForwardRef as ReactComponent };